import { useState, useRef, useCallback } from 'react'
import axios from 'axios'
import { CB_SEARCH_DETAILS_V2 } from '../../../../../ApiUrl'
import { requestHeader } from '../../../../../others/header'

export const useCandidateDetails = () => {
  const [detailsCache, setDetailsCache] = useState({})
  const [loading, setLoading] = useState({})
  const [error, setError] = useState({})
  const abortControllersRef = useRef({})

  const fetchDetails = useCallback(async (candidateData) => {
    const sid = candidateData?.id;
    if (!sid) {
      console.error('No ResumeID found in candidate data:', candidateData);
      return;
    }

    const existingCandidateId = candidateData?.candidateId;
 

    if (abortControllersRef.current[sid]) {
      abortControllersRef.current[sid].abort();
    }

    const controller = new AbortController();
    abortControllersRef.current[sid] = controller;
    
    setLoading(prev => ({ ...prev, [sid]: true }));
    setError(prev => ({ ...prev, [sid]: null }));

    try {
      
      const encodedResumeId = encodeURIComponent(sid);
      
      const response = await axios.get(
        `${CB_SEARCH_DETAILS_V2}/${encodedResumeId}`,
        {
          ...requestHeader(),
          signal: controller.signal
        }
      );

      if (response.data.error !== false) {
        throw new Error(response.data.message || 'Error fetching candidate details');
      }

      const candidateDetails = response.data.data;
      
      if (!candidateDetails) {
        throw new Error('Empty response data from API');
      }
      
      
      const mongoDbId = candidateDetails.candidateId || 
                       candidateDetails._id || 
                       existingCandidateId || 
                       null;
      
      setDetailsCache(prev => ({
        ...prev,
        [sid]: {
          data: candidateDetails,
          candidateId: mongoDbId,
          timestamp: Date.now()
        }
      }));
      return candidateDetails;
    } catch (err) {
      console.error('Error in fetchDetails:', err);
      if (err.name !== 'CanceledError') {
        setError(prev => ({ ...prev, [sid]: err.message }));
      }
      throw err;
    } finally {
      setLoading(prev => ({ ...prev, [sid]: false }));
      delete abortControllersRef.current[sid];
    }
  }, []);

  return { fetchDetails, detailsCache, loading, error }
}
